"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC1967Proxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ERC1967Proxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_logic, _data, overrides) {
        return super.getDeployTransaction(_logic, _data, overrides || {});
    }
    deploy(_logic, _data, overrides) {
        return super.deploy(_logic, _data, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ERC1967Proxy__factory = ERC1967Proxy__factory;
ERC1967Proxy__factory.bytecode = _bytecode;
ERC1967Proxy__factory.abi = _abi;
//# sourceMappingURL=ERC1967Proxy__factory.js.map